/* @flow weak */
import Glyph from 'components/Glyph';
import ModalMenuItem from 'components/ModalMenuItem';
import * as React from 'react';
import ReportToRemindSelectModal from 'support/components/ReportToRemindSelectModal';
import UserActions from 'user/UserActions';

type Props = {
  reportee: {
    uuid: string,
    name: string,
  },
  disabled: boolean,
};

class ReportUserMenuItem extends React.Component<Props> {
  reportParticipant = (key, notes) => {
    UserActions.reportUser(this.props.reportee.uuid, key, notes);
  };

  renderReportDialog = () => {
    return (
      <ReportToRemindSelectModal
        reportee={this.props.reportee.name}
        notesPlaceholder="Why are you reporting this participant?"
        onReport={this.reportParticipant}
      />
    );
  };

  render() {
    return (
      <ModalMenuItem
        modal={this.renderReportDialog()}
        disabled={this.props.disabled}
        {...this.props}>
        <Glyph name="flag" />
        <span>Report to Remind</span>
      </ModalMenuItem>
    );
  }
}

export default ReportUserMenuItem;
